import { TextEditorModule } from './../../components/text-editor/text-editor.module'
import { UISettingsComponent } from './ui-settings.component'
import { uiRoutes } from './ui-settings.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [UISettingsComponent],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(uiRoutes, { scrollPositionRestoration: 'top' }),
    HttpClientModule,
    SharedModule,
    TextEditorModule,
    BreadcrumbsModule,
  ],
  exports: [UISettingsComponent],
})
export class UISettingsModule {}
